import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  InputGroup,
  Button,
} from "react-bootstrap";
import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import FormControl from "react-bootstrap/FormControl";

import "../App.css";

export default function LoginLanding() {
  const [authenticationFailed, setAuthenticationFailed] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const passwordRef = useRef(null);
  const brandTextRef = useRef(null);
  const workshopNaturalWidthRef = useRef(null);
  const [workshopEm, setWorkshopEm] = useState(1);

  useLayoutEffect(() => {
    const measure = () => {
      const brandEl = brandTextRef.current;
      const naturalEl = workshopNaturalWidthRef.current;
      if (!brandEl || !naturalEl) return;
      const tw = brandEl.getBoundingClientRect().width;
      const w = naturalEl.getBoundingClientRect().width;
      if (w < 0.01 || tw < 0.01) return;
      const next = tw / w;
      setWorkshopEm((prev) => (Math.abs(prev - next) < 0.0005 ? prev : next));
    };
    measure();
    const parent = brandTextRef.current?.parentElement;
    const ro = parent ? new ResizeObserver(measure) : null;
    if (parent && ro) ro.observe(parent);
    window.addEventListener("resize", measure);
    return () => {
      if (ro) ro.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, []);

  useEffect(() => {
    document.title = 'Artificial Intelligence Workshop | STAGE ONE EDUCATION';
  }, []);

  function authenticate(passwordValue) {
    fetch("/authenticate_frontend", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ password: passwordValue }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.authenticated && data.workshop_type) {
          setAuthenticationFailed(false);

          const workshopType = data.workshop_type;
          const storagePrefix = workshopType === 'mission' ? 'mission' : 'film';
          localStorage.setItem(`${storagePrefix}-frontend-password`, passwordValue);

          const redirectPath = workshopType === 'mission' ? '/ai-mission' : '/ai-film';
          window.location.href = redirectPath;
        } else {
          setAuthenticationFailed(true);
        }
      })
      .catch((error) => {
        console.error("Authentication request error:", error);
        setErrorMessage(error.toString());
      });
  }

  const openManageServers = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const host = window.location.hostname;
    const port = window.location.port;
    const isLocalDev = (host === 'localhost' || host === '127.0.0.1') && (port === '3000' || port === '3001');
    const managePort = port === '3001' ? '3000' : '3001';
    const manageUrl = isLocalDev
      ? `http://${host}:${managePort}/manage-servers/`
      : '/manage-servers/';
    window.open(manageUrl, '_blank', 'noopener,noreferrer');
  };

  let errorMessageToast = <></>;
  if (errorMessage) {
    errorMessageToast = (
      <ToastContainer position="bottom-center" containerPosition="fixed" style={{ zIndex: 99999 }}>
        <Toast
          show={errorMessage != null}
          onClose={() => setErrorMessage(null)}
          style={{ marginBottom: "90px", backgroundColor: "#dddddd", zIndex: 99999 }}
        >
          <Toast.Header>
            <strong className="me-auto" style={{ fontSize: 'large' }}>Error</strong>
          </Toast.Header>
          <Toast.Body style={{ textAlign: "center" }}>
            {errorMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    );
  }

  let failedText = <></>;
  if (authenticationFailed) {
    failedText = <><br /><span style={{ color: 'red' }}>Authentication failed</span></>;
  }

  return (
    <div style={{
      backgroundColor: '#f5f5f5',
      minHeight: '100vh',
      width: '100vw',
      position: 'fixed',
      top: 0,
      left: 0,
      overflow: 'auto'
    }}>
      <div style={{
        backgroundColor: '#f05f40',
        padding: '0.26rem 0.85rem',
        width: '100%',
        position: 'relative',
        zIndex: 10
      }}>
        <Container fluid style={{ padding: '0 10px' }}>
          <div style={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}>
            <span
              style={{
                color: 'white',
                fontSize: 'clamp(9px, 3.5vw, 18px)',
                lineHeight: '1.2',
                fontFamily: 'Roboto, sans-serif',
                display: 'flex',
                alignItems: 'center',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                position: 'relative',
              }}
            >
              <strong ref={brandTextRef}>STAGE ONE EDUCATION</strong>
              <span
                style={{
                  display: 'inline-block',
                  width: '1px',
                  height: '1em',
                  backgroundColor: 'white',
                  opacity: 0.7,
                  margin: '0 clamp(2px, 0.5vw, 6px)',
                  flexShrink: 0,
                }}
              />
              <span
                aria-hidden="true"
                ref={workshopNaturalWidthRef}
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  visibility: 'hidden',
                  pointerEvents: 'none',
                  whiteSpace: 'nowrap',
                  fontSize: '1em',
                  fontWeight: 'normal',
                  fontFamily: 'inherit',
                }}
              >
                Artificial Intelligence Workshop
              </span>
              <span style={{ fontSize: '1em', fontWeight: 'normal', flexShrink: 0 }}>
                Artificial Intelligence Workshop
              </span>
            </span>
          </div>
        </Container>
      </div>

      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: 'min(6vh, 50px)',
        position: 'relative',
        zIndex: 2
      }}>
        <div className="portal-card" style={{
          width: '80vw',
          maxWidth: '800px',
          backgroundColor: 'white',
          borderRadius: 'min(1vw, 8px)',
          padding: 'min(3vw, 3vh, 20px)',
          boxShadow: '0 0 15px rgba(240, 95, 64, 0.5)'
        }}>
          <Container style={{ marginTop: 'min(2vh, 1rem)' }}>
            <Row style={{ marginBottom: 'min(2vh, 1rem)' }}>
              <Col>
                <p style={{ fontFamily: 'Roboto, sans-serif', fontWeight: 'normal', fontSize: 'min(2vw, 2.5vh, 16px)', marginBottom: 'min(1.2vh, 10px)' }}>Password:</p>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    const passwordValue = passwordRef.current.value;
                    authenticate(passwordValue);
                  }}
                >
                  <InputGroup className="portal-input-group">
                    <FormControl
                      className="portal-password-input"
                      type="text"
                      placeholder=""
                      aria-label="Password"
                      aria-describedby="password-addon"
                      ref={passwordRef}
                      autoFocus
                      key="passbox"
                      style={{ fontSize: 'min(3vw, 3.5vh, 24px)' }}
                    />
                    <Button className="portal-submit-btn" type="submit" style={{ fontSize: 'min(2vw, 2.5vh, 16px)' }}>Submit</Button>
                  </InputGroup>
                </Form>
                {failedText}
              </Col>
            </Row>
            {errorMessageToast}
          </Container>
        </div>
      </div>

      <div style={{
        position: 'fixed',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        color: '#999999',
        fontSize: '12px',
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 'normal',
        zIndex: 9999,
        whiteSpace: 'nowrap'
      }}>
        &copy; 2026 Stage One Education, LLC
      </div>

      <div
        className="gear-icon"
        onClick={openManageServers}
        style={{
          position: 'fixed',
          bottom: '20px',
          left: '20px',
          fontSize: '14px',
          color: 'white',
          cursor: 'pointer',
          zIndex: 9999,
          opacity: 1
        }}
      >
        <FontAwesomeIcon icon={faCog} />
      </div>
    </div>
  );
}
